(function () {
  const MOBILE_BREAKPOINT = 750;
  const instances = new Map();

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function getSwiperOptions(paginationEl) {
    return {
      slidesPerView: 1.12,
      spaceBetween: 16,
      grabCursor: true,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    };
  }

  function initGetInTouch(container) {
    if (typeof Swiper === 'undefined') return;

    const swiperEl = container.querySelector('.get-in-touch__swiper');
    const paginationEl = container.querySelector('.get-in-touch__pagination');

    if (!swiperEl) return;

    const existing = instances.get(container);
    if (existing) {
      existing.destroy(true, true);
      instances.delete(container);
    }

    if (!isMobile()) return;

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount < 2) return;

    const swiper = new Swiper(swiperEl, getSwiperOptions(paginationEl));
    instances.set(container, swiper);
  }

  function initAll() {
    document.querySelectorAll('[data-get-in-touch]').forEach(initGetInTouch);
  }

  function onReady() {
    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', initAll, { once: true });
      return;
    }
    initAll();
  }

  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('[data-get-in-touch]');
    if (container) initGetInTouch(container);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const container = event.target.querySelector('[data-get-in-touch]');
    if (!container) return;
    const existing = instances.get(container);
    if (existing) {
      existing.destroy(true, true);
      instances.delete(container);
    }
  });
})();
